import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getBrigades, addBrigade, editBrigade, deleteBrigade, getBrigadeByKey } from "../../redux/actions/brigadeActions";
import CreateBrigade from "./Popups/CreateBrigade";
import BrigadeDetails from "./Popups/BrigadeDetails";
import EditBrigade from "./Popups/EditBrigade";
import RemoveBrigade from "./Popups/RemoveBrigade";

function createData(id, number, createdAt, addressLine, schema, data, address, disinfector, type) {
    return {id, number, createdAt, addressLine, schema, data, address, disinfector, type};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", "abc", null, null, null, null, null),
];
const BrigadeList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("brigadeList.tableItem.id")},
        {text: t("brigadeList.tableItem.number")},
        {text: t("brigadeList.tableItem.createdAt")},
        {text: t("brigadeList.tableItem.addressLine")},
        {text: t("brigadeList.tableItem.schema")},
        {text: t("brigadeList.tableItem.data")},
        {text: t("brigadeList.tableItem.address")},
        {text: t("brigadeList.tableItem.disinfector")},
        {text: t("brigadeList.tableItem.type")},
        {text: t("brigadeList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addBrigade(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getBrigadeByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getBrigadeByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editBrigade(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getBrigadeByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteBrigade(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.brigade);
    if (!localData && state.brigades)
    {
        rows = state.brigades;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getBrigades(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("brigadeList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("brigadeList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    addressLine: _.addressLine,
                    schema: _.schema,
                    data: _.data,
                    address: _.address?.name,
                    disinfector: _.disinfector?.fullName,
                    type: _.type?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateBrigade action={'create'} title={t("brigadeList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <BrigadeDetails action={'details'} title={t("brigadeList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditBrigade action={'edit'} title={t("brigadeList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveBrigade action={'remove'} title={t("brigadeList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default BrigadeList;
